// extracted by mini-css-extract-plugin
export var divider = "_qy-0";
export var systemMessage = "_qy-1";
export var systemMessageWrapper = "_qy-2";